import type { OptionalError } from "@somewear/model";
import { cn } from "@somewear/ui";
import { CenterContent } from "@web/common/Common";
import BaseControlledInputView from "@web/common/ControlledInputView";
import * as React from "react";

interface IFirstInput extends OptionalError {
	children: React.ReactNode;
	className?: string;
}

interface IText {
	text: string;
}

export const Header: React.FunctionComponent<IText> = (text: IText) => (
	<div className="text-3xl md:text-4xl font-bold font-title leading-tight tracking-wider text-center text-black mb-4 uppercase">
		{text.text}
	</div>
);

export const CenterHeader: React.FunctionComponent<IText> = (text: IText) => (
	<CenterContent>
		<Header text={text.text} />
	</CenterContent>
);

export const ErrorMessage: React.FunctionComponent<OptionalError & { className?: string }> = (
	props,
) => (
	<div className={cn("row text-red-500", { "!hidden": !props.error }, props.className)}>
		<div className="flex justify-center col-span-12 p-4">
			<div className="w-full text-center text-red-500" role="alert">
				{props.error?.message || "Something went wrong"}
			</div>
		</div>
	</div>
);

export const FirstInput: React.FunctionComponent<IFirstInput> = (props: IFirstInput) => (
	<div className="row">
		<div className="col-span-12 justify-center">{props.children}</div>
	</div>
);

export const Button: React.FC<
	React.ButtonHTMLAttributes<HTMLButtonElement> & { children: React.ReactNode }
> = (props) => (
	<button
		{...props}
		className={cn(
			"w-full h-14 rounded-md bg-black mb-1.5 disabled:bg-gray-400",
			props.className,
		)}
	/>
);

export const LinkButton: React.FC<React.HTMLAttributes<HTMLParagraphElement>> = (props) => (
	<p
		{...props}
		className={cn(
			"text-blue-500 leading-tight font-normal text-sm tracking-wider text-center cursor-pointer uppercase",
			props.className,
		)}
	/>
);

export const ControlledInputView: React.FC<React.ComponentProps<typeof BaseControlledInputView>> = (
	props,
) => {
	return (
		<BaseControlledInputView
			{...props}
			className={cn(
				"font-normal mb-2.5 w-full max-w-full rounded-lg border border-gray-600 bg-transparent h-14 p-5 placeholder:uppercase",
				props.className,
			)}
		/>
	);
};

export const InputView = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
	(props, ref) => {
		return (
			<input
				{...props}
				ref={ref}
				className={cn(
					"font-normal mb-2.5 w-full max-w-full rounded-lg border border-gray-600 bg-transparent h-14 p-5 placeholder:uppercase",
					props.className,
				)}
			/>
		);
	},
);
